export default {
   apiKey: "AIzaSyBoKIxO692NsIVchyKc2Wgq3lqbKMkmc3U",
   authDomain: "routine-diu.firebaseapp.com",
   databaseURL: "https://routine-diu.firebaseio.com",
   projectId: "routine-diu",
   storageBucket: "routine-diu.appspot.com",
   messagingSenderId: "398005507719"
}